import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import LisaMarieBarber from "../views/LisaMarieBarber.vue";
import CocoKlockner from "../views/CocoKlockner.vue";
import JeanneQuinn from "../views/JeanneQuinn.vue";
import DiedrickBrackens from "../views/DiedrickBrackens.vue";


Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home
  },
  {
    path: "/about",
    name: "About",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/About.vue")
  },
  {
    path: "/jeannequinn",
    name: "JeanneQuinn",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: JeanneQuinn
  },
  {
    path: "/cocoklockner",
    name: "CocoKlockner",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: CocoKlockner
  },
  {
    path: "/lisamariebarber",
    name: "LisaMarieBarber",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: LisaMarieBarber
  },
  {
    path: "/diedrickbrackens",
    name: "DiedrickBrackens",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: DiedrickBrackens
  }
];

const router = new VueRouter({
  routes
});

export default router;
